export enum APP_PAGE_PATH {
  LOGIN = '/login',
  REGISTER = '/register',
  RESET_PASSWORD_SUCCESS = '/reset-password-success',
}
